/* eslint-disable indent */
import { RenderScreen } from '@/pages/tasklist/Screen/ScreenLoader';
import { Button } from 'alurkerja-ui';
import { X } from 'lucide-react';
import { createContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const MyRequestModalContext = createContext<{
  fromMyRequest: boolean;
  closeModal: () => void;
}>({
  fromMyRequest: false,
  closeModal: () => {
    return;
  },
});

export default function ModalRequestForm() {
  const { processKey } = useParams();
  const navigate = useNavigate();

  const getBack = () => {
    navigate('/my-request');
  };

  return (
    <div className="flex justify-center items-start fixed top-0 left-0 w-screen h-screen bg-black/[.50] z-40 pt-0 sm:pt-10 overflow-y-auto">
      <div className="w-screen min-h-screen sm:min-h-min sm:w-[600px] md:w-[800px] p-2 sm:p-6 bg-white rounded-lg space-y-4">
        <div className="flex justify-between items-center">
          <h1 className="text-lg font-semibold">Start Process {processKey}</h1>
          <Button
            className="bg-red-50 hover:bg-red-200"
            size="small"
            onClick={getBack}
            icon={<X color="red" />}
          ></Button>
        </div>
        <div>
          <MyRequestModalContext.Provider value={{ fromMyRequest: true, closeModal: getBack }}>
            <RenderScreen taskDefinitionKey={'STARTPROCESS'} processDefinitionKey={processKey}></RenderScreen>
          </MyRequestModalContext.Provider>
        </div>
      </div>
    </div>
  );
}
